export default __webpack_public_path__ + "static/media/logo.0f892f34.png";